export default {
    mounted() {
        this.el.addEventListener("click", (e) => {
            this.el.disabled = true;
            this.el.innerText = "Loading...";

            let form = this.el.closest("form");
            if (form) {
                form.submit();
            }
        });
    },
}
